module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAJCAYAAAA/33wPAAAAAXNSR0IArs4c6QAAAKFJREFUKFONkkESATEQAHuv/IT3cMWZPyh/WGdceQ8/4ay6TLZiJSq5ZJJM9Uwn6fiMPXADHrFunWbAAjh0EVyBJ7AFLo2UFXAEpjIEGfTAOgAnYAe8KsBJ5G/i/Gy+oDQECRR8B5YFVVXsfh4GFhREDnJdTQRylZ9CY5Cwkqr7XyrR0aBTApVU3fMxBpXx/f0D5arGpTtr6iglqZo6qv6MN9y+ImkCdhyFAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/data-base/arrow-down.png
// module id = XwiL
// module chunks = 1